import { createContext } from 'react';

import type { ABTesting } from '../../types/types';

const defaultContext: ABTesting.ContextProps = {
  branch: null,
  trigger: 'load',
  hasTriggerFired: false,
  selector: undefined,
  triggerCurrentTest: () => undefined,
  shouldShowShield: false,
  branchesToRender: [],
};

export default createContext(defaultContext);
